// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"126":"0e7f61bf","356":"c2ef4f3e","447":"3ac4d9e0","486":"c2ef4f3e","772":"c2ef4f3e"}[chunkId] + ".chunk.css";
};